import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Autocomplete, Box, Button, Card, Drawer, FormControlLabel, Modal, Paper, Radio, RadioGroup, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { CommonPatientDetails, ConfirmPopup, ConsultantPatientCard } from '../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../Styles/Colors';
import { renderCorpInsuranceCard } from '../../../../Components/CommonFunctions/CommonFunctions';
import '../../../FrontOffice/IPPatients/PatientsDetails/IpPatientDetails.css'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import MenuOpenIcon from '@mui/icons-material/MenuOpen'; import '../DoctorNotes.css'
import DocSymptomsLeft from './DocSymptomsLeft';
import { Other_Doctor_Notes_Layout_JSON } from '../../../../Utility/Constants';
import DocSymptomsRight from './DocSymptomsRight';
import DocDiagnosisLeft from './DocDiagnosisLeft';
import DocDiagnosisRight from './DocDiagnosisRight';
import DocGenAdviceRight from './DocGenAdviceRight';
import DocGenAdviceleft from './DocGenAdviceleft';
import DocPatientCetegoryRight from './DocPatientCetegoryRight';
import DocPatientCategoryLeft from './DocPatientCategoryLeft';
import DocAllergiesLeft from './DocAllergiesLeft';
import DocAllergiesRight from './DocAllergiesRight';
import DocExaminationRight from './DocExaminationRight';
import DocExaminationLeft from './DocExaminationLeft';
import DocPrecriptionRight from './DocPrecriptionRight';
import DocPrescriptionLeft from './DocPrescriptionLeft';
import DocTestLeft from './DocTestLeft';
import DocTestRight from './DocTestRight';
import DocPlanRight from './DocPlanRight';
import DocPlanLeft from './DocPlanLeft';
import DocCounsellingRight from './DocCounsellingRight';
import DocCounsellingLeft from './DocCounsellingLeft';
import DocVitalsLeft from './DocVitalsLeft';
import DocVitalsRight from './DocVitalsRight';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { DateTime } from 'luxon';
import DocReviewPlanLeft from './DocReviewPlanLeft';
import DocReviewPlanRight from './DocReviewPlanRight';
import DocClinicExamENTLeft from './DocClinicExamENTLeft';
import DocClinicExamENTRight from './DocClinicExamENTRight';
import OtherDoccomplaintsRight from './OtherDoccomplaintsRight';
import OtherDocComplaintsLeft from './OtherDocComplaintsLeft';
import DocClinicalHistoryLeft from './DocClinicalHistoryLeft';
import DocClinicalHistoryRight from './DocClinicalHistoryRight';
import ErrorIcon from '@mui/icons-material/Error';
import DocFinalDiagnosisRight from './DocFinalDiagnosisRight';
import DocFinalDiagnosisLeft from './DocFinalDiagnosisLeft';
import DocPainScaleLeft from './DocPainScaleLeft';
import DocPainScaleRight from './DocPainScaleRight';
import OldDocTestRight from './OldDocTestRight';
import OldDocTestLeft from './OldDocTestLeft';
import DocPastHistoryLeft from './DocPastHistoryLeft';
import DocPastHistoryRight from './DocPastHistoryRight';
import DocNewLayoutLeft from './DocNewLayoutLeft';
import DocNewLayoutRight from './DocNewLayoutRight';
import DocObstericDataLeft from './DocObstericDataLeft';
import DocObstericDataRight from './DocObstericDataRight';
import DocHistoryofIllnessLeft from './DocHistoryofIllnessLeft';
import DocHistoryofIllnessRight from './DocHistoryofIllnessRight';
import PreviousDiagnosis from '../Common/PreviousDiagnosis';
import HistoryIcon from '@mui/icons-material/History';

const urlCheck = {
    "diagnosis": "DOC_PREVIOUS_DIAGNOSIS_GET",
    "final_diagnosis": "DOC_PREVIOUS_FINAL_DIAGNOSIS_GET"
}

const showRow = new Set(["clinicExam", "diagnosis", "final_diagnosis"])

class OtherDoctorNotes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            clinicId: localGetItem('SelectedDoctorClinicId'),
            PatientData: {},
            SelectedComponent: null,
            SelectedCompCustomName: "",
            IPadmissionDetails: {},
            CallGetComponent: "",
            EditSymptomsData: {},
            EditComplaintData: {},
            EditCounsellingData: {},
            EditReviewPlanData: {},
            EditPlanDatas: {},
            EditExaminationsData: {},
            EditGenAdviceText: "",
            EditFinalDiagnosisTxt: "",
            EditClinicalHistText: "",
            withOutAppointment: {},
            EditAllergyData: {},
            EditPrescriptionData: {},
            EditPainScaleData: {},
            DocNotesLayout: [],
            TransferPopup: false,
            SpecializationInfo: [],
            SpecdocDetails: [],
            filteredDocList: [],
            filterspcInfo: [],
            Specilazation: null,
            Doctor: null,
            layoutloading: true,
            ClearClickedonRightPrecs: false,
            isLocked: false,
            TranferMethod: "Transfer Appointment",
            spcInfo: [],
            selectedspec: null,
            docDetails: [],
            selectedDoc: null,
            POVList: [],
            PurposeOfVisit: "",
            allergyData: [],
            prescriptionList: [],
            examinePopup: false,
            EditDiagnosisData:{},
            EditComplaintData: {},
            loginInfo:null,
            doctorMandatory:JSON.parse(localGetItem("loggedInUserInfo"))?.token_gen_type === "Specialization" ? false : true,
            postAppTransLoad:false,
            postTransLoad:false,
            successPopup: false,
            successPopupTxt: '',
            smsSuccessTxt: '',
            addendumPopup: false,
            addendumLogPopup: false,
            addendumLogList: [],
            isNewBilling: localGetItem('isNewBilling') === 'true' ? true : false,
            EditPastHistoryData: {},
            patientPrimType: {},
            patientDetails: {},
            isNewLayout: {},
            dynamicState: {},
            hasFetched: null,
            editDynamicState: {},
            EditObstericData: {},
            EditVitalsData: [],
            right_Fields_data: [],
            filteredRightField_data: [],
            EditPresentingIllnessData: {},
            PreviousDiagnosisPopup: false,
            dateList: [],
            PreviousData: [],
            fnldateList: [],
            fnlPreviousData: [],
            title: "",
            fieldName: "",
            postDiagnosisData: {},
            postFnlData: {},
            is_previous_loading: false,
            isWahtsAppText: '',
        }
        this.divRefs = [];
    }

    componentDidMount() {
        let PatientData = getCachevalue("DoctorPatientData")
        let patientData = JSON.parse(PatientData)
        let ServiceType = localGetItem("loggedInUserInfo")
        let myUser = JSON.parse(ServiceType)
        let POVList = localGetItem("PurposeOfVisit") === null ? '[]' : localGetItem("PurposeOfVisit")
        let array = []
        JSON.parse(POVList).forEach(element => array.push(element.reason));
        if (array.length > 0) {
            this.setState({
                POVList: array
            })
        }
        this.setState({
            PatientData: patientData,
            appointmentId: patientData?.appointment_id,
            patientId: patientData?.patient_id,
            isLocked: getCachevalue('DoctorUserChanged') === 'true' ? true : patientData?.transfer_appointment ? patientData?.transfer_appointment : patientData?.is_locked,
            TransferDisable: patientData?.is_transmitted ? patientData?.is_transmitted : false,
            loginInfo:ServiceType
        }, () => {
            this.getDoctorNotesLayout()
            this.getDoctorDetails(myUser?.doctor_id ? myUser?.doctor_id : null)
            this.getPatientPrimaryData()
            this.getPatientDetailData()
            this.getVitalLayoutConfigData()
        })
    }

    getDoctorDetails = (CurrentDocID) => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?clinic_id=${this.state.clinicId}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let List = response.data.data ? response.data.data.filter((item) => (item?.doctor_id !== CurrentDocID)) : []
                        this.setState({
                            docDetails: List,
                        })
                    }
                })
                .catch(error => {
                    if (error.response?.data?.status === "fail") {
                        this.errorMessage(error.response?.data?.message);
                    }
                });
        } catch (e) {
            this.errorMessage(e.message);
        }
    }

    getPatientDetailData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: response?.data?.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getPatientPrimaryData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_PRIMARY_PAYMENT_GET + '?appointment_id=' + this.state.appointmentId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientPrimType: response?.data?.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getPreviousDiagnosis = (date = "", SelectedComponent = "") => {
        try {
            const fieldName = SelectedComponent || this.state.SelectedComponent || this.state.fieldName || "";
            let url = `${Serviceurls[urlCheck[fieldName]]}?patient_id=${this.state.patientId}&appointment_id=${this.state.appointmentId}`
            this.setState({ [`${fieldName === "diagnosis" ? "PreviousData" : "fnlPreviousData"}`]: [], is_previous_loading: true });
            RestAPIService.getAll(url + (date ? `&date=${date}` : ""))
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const responseData = response?.data?.data || [];
                        const dates = date ? this.state[`${fieldName === "diagnosis" ? "" : "fnl"}dateList`] : response?.data?.dates || [];

                        // Process the data
                        const processedData = responseData?.map((item) => ({
                            appointment_id: item.appointment_id,
                            icd_code: item.icd_codes,
                            diagnosis: item.provisional_diagnosis || item.comments
                        }))

                        const stateUpdate = {
                            [`${fieldName === "diagnosis" ? "" : "fnl"}dateList`]: dates,
                            [`${fieldName === "diagnosis" ? "PreviousData" : "fnlPreviousData"}`]: processedData,
                            is_previous_loading: false
                        };

                        this.setState(stateUpdate);
                    }
                }).catch((error) => {
                    this.setState({ is_previous_loading: false });
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            this.setState({ is_previous_loading: false });
            this.errorMessage(error.message)
        }
    }

    generateStatekey = (value) => {
        return value?.toLowerCase()?.replace(/\s+/g, "_")
    }

    getNewLayoutData = (forceFetch = "") => {
        try {
            if (forceFetch && this.state.hasFetched === forceFetch) return;
            RestAPIService.getAll(Serviceurls.DOC_NEW_LAYOUT_GET + '?patient_id=' + this.state.patientId + '&appointment_id=' + this.state.appointmentId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const dynamicState = Object.entries(response.data.data).reduce((acc, [key, value]) => {
                            const stateKey = this.generateStatekey(key);
                            acc[stateKey] = {
                                id: value.id,
                                patient_id: value.patient_id,
                                appointment_id: value.appointment_id,
                                system_name: value.system_name,
                                custom_name: value.custom_name,
                                comments: value.comments || "",
                            };
                            return acc;
                        }, {});
                        this.setState({
                            dynamicState: dynamicState || {},
                            hasFetched: forceFetch,
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    callNewLayoutData = (fetchData) => {
        this.getNewLayoutData(fetchData);
    }

    allergyData = (data) => {
        this.setState({ allergyData: data })
    }

    getDoctorNotesLayout = () => {
        try {
            this.setState({ layoutloading: true })
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            let Doctor_Notes_Layout = JSON.parse(JSON.stringify(Other_Doctor_Notes_Layout_JSON))
            if (UserData?.service_type === "ENT") {
                let ENTLayout = { id: Doctor_Notes_Layout?.length + 1, field_name: 'clinicExam', label: 'Clinical Examination', is_active: true }
                Doctor_Notes_Layout?.push(ENTLayout)
            }
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const {field_data} = response.data.data;
                        this.setState({
                            DocNotesLayout: field_data?.left_data ? field_data?.left_data : Doctor_Notes_Layout,
                            layoutloading: false
                        }, () => {
                            for (let i = 0; i < this.state.DocNotesLayout?.length; i++) {
                                this.divRefs[i] = React.createRef();
                            }
                            this.setState({
                                SelectedComponent: this.state.DocNotesLayout[0]?.field_name,
                                SelectedCompCustomName: this.state.DocNotesLayout[0]?.custom_name,
                                isNewLayout: this.state.DocNotesLayout[0]?.is_new ? this.state.DocNotesLayout[0] : {},
                            }, () => {
                                // this.TriggerGetApi(this.state.DocNotesLayout[0]?.field_name)
                            })
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({ layoutloading: false })
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.setState({ layoutloading: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ layout: false })
            this.errorMessage(error.message)
        }
    }

    getPatientData = () => {
        let admission_id = this.state.PatientData?.id || this.state.withOutAppointment?.ip_admission_id;
        try {
            RestAPIService.getAll((localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW) + '?admission_id=' + admission_id)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            IPadmissionDetails: response.data.data[0]
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getAddendumLogData = () => {
        try {
          RestAPIService.getAll(Serviceurls.GET_ADDENDUM_LOG + `?appointment_id=${this.state.appointmentId}`)
            .then((response) => {
              if (response.data.status === "success") {
                this.setState({
                  addendumLogList: response.data?.data ? response.data?.data : []
                })
              }
            }).catch((error) => {
              if (error?.response?.data?.status === 'fail') {
                this.errorMessage(error.response.data.message)
              } else {
                this.errorMessage(error.message)
              }
            })
        } catch (error) {
          this.errorMessage(error.message)
        }
      }

    getVitalLayoutConfigData = () => {
        try {
            let clinicData = localGetItem('SelectedDoctorClinicId') ? JSON.parse(localGetItem('SelectedDoctorClinicId')) : null;
            // let clinicData = getCachevalue("SelectedDoctorClinic") ? JSON.parse(getCachevalue("SelectedDoctorClinic")) : null;
            let patientData = getCachevalue("DoctorPatientData") ? JSON.parse(getCachevalue("DoctorPatientData")) : null;
            let specialization_id = patientData?.speciality_id || patientData?.specialization_id || null;
            RestAPIService.getAll(`${Serviceurls.VITALS_CONFIGURATION}?specialization_id=${specialization_id}&clinic_id=${clinicData ? clinicData : null}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        const right_Fields_data = response?.data?.data?.[0]?.vital_layout_data || [];
                        this.setState({
                            right_Fields_data,
                            filteredRightField_data: right_Fields_data?.filter(item => item?.is_active) || []
                        });
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })

        } catch (e) {
            this.errorMessage(e?.message)
        }
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }
    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    TriggerGetApi(component) {
        this.setState({
            CallGetComponent: component
        }, () => {
            setTimeout(() => { this.setState({ CallGetComponent: "" }) }, 500)
        })
    }

    EditSymptomData(data) {
        this.setState({
            EditSymptomsData: data
        })
    }
    EditComplaintData(data) {
        this.setState({
            EditComplaintData: data
        })
    }
    EditCounsellingData(data) {
        this.setState({
            EditCounsellingData: data
        })
    }
    EditReviewPlanData(data) {
        this.setState({
            EditReviewPlanData: data
        })
    }
    EditClinicalExamNotes(data) {
        this.setState({
            EditClinicalExamNotes: data
        })
    }
    EditPlanDatas(data) {
        this.setState({
            EditPlanDatas: data
        })
    }
    EditExaminationsData(data) {
        this.setState({
            EditExaminationsData: data
        })
    }
    EditDiagnosisData(data){
        this.setState({
            EditDiagnosisData: data
        })
    }
    EditGenAdviceText(data) {
        this.setState({
            EditGenAdviceText: data
        })
    }
    EditFinalDiagnosisTxt(data) {
        this.setState({
            EditFinalDiagnosisTxt: data
        })
    }
    EditClinicalHistText(data) {
        this.setState({
            EditClinicalHistText: data
        })
    }
    EditPrescriptionData(data) {
        this.setState({
            EditPrescriptionData: data
        })
    }
    EditAllergyData(data) {
        this.setState({
            EditAllergyData: data
        })
    }
    AddPrescritionItem(data) {
        this.setState({
            AddPrescritionItem: data
        })
    }
    AddClinicalExamNotes(data) {
        this.setState({
            clinicalExamNotes: data
        })
    }
    isDataSaved = () => {
        this.setState({
            examinePopup: false
        })
    }
    ClearClickedonRightPrecs(flag) {
        this.setState({
            ClearClickedonRightPrecs: flag
        })
    }
    handleDisableTransfer(flag) {
        this.setState({
            TansmitDisable: flag
        })
    }
    EditPainScaleData(data) {
        this.setState({
            EditPainScaleData: data
        })
    }

    EditPastHistoryData(data) {
        this.setState({
            EditPastHistoryData: data
        })
    }
    EditPresentingIllnessData(data) {
        this.setState({
            EditPresentingIllnessData: data
        })
    }

    EditNewLayoutText(data, statekey){
        this.setState((prevState) => ({
            editDynamicState: {
                ...prevState.editDynamicState,
                [statekey]: data
            }
        }))
    }

    setVitalsData(data) {
        this.setState({
            EditVitalsData: data
        })
    }

    triggerPreviousHistory = (fieldName) => {
        this.getPreviousDiagnosis("", fieldName);
    }

    closePreviousPopUp = () => {
        this.setState({ PreviousDiagnosisPopup: false })
    }
    
    ClearPropsData(stateKey) {
        this.setState((prevState) => ({
            EditSymptomsData: {},
            isEdit :false,
            EditComplaintData :{},
            EditCounsellingData: {},
            EditPlanDatas: {},
            EditExaminationsData: {},
            EditGenAdviceText: "",
            EditFinalDiagnosisTxt: "",
            EditClinicalHistText: "",
            EditAllergyData: {},
            EditPrescriptionData: {},
            EditReviewPlanData: {},
            ClearClickedonRightPrecs: false,
            EditDiagnosisData:{},
            EditPainScaleData: {},
            EditObstericData: {},
            EditPastHistoryData: {},
            EditPresentingIllnessData: {},
            ...(stateKey ? { editDynamicState: {   
                ...prevState.editDynamicState,  
                [stateKey]: ""
            }} : {})
        }))
    }

    renderComponent(Component, customName="", isNew = false) {
        let Userdata = localGetItem("loggedInUserInfo")
        let UserInfo = JSON.parse(Userdata)
        switch (Component) {
            case "symptoms":
                return <DocSymptomsLeft
                    fromDocModule={true}
                    PatientData={this.state.PatientData}
                    EditSymptomData={this.EditSymptomData.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'symptoms'}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedComponent={this.state.SelectedComponent}
                    custom_name = {customName}
                />

            case "examination":
                return <DocExaminationLeft
                    PatientData={this.state.PatientData}
                    EditExaminationsData={this.EditExaminationsData.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'examination'}
                    isLocked={this.state.isLocked}
                    custom_name = {customName}
                />

            case "diagnosis":
                return <DocDiagnosisLeft
                    PatientData={this.state.PatientData}
                    GetAPiCall={this.state.CallGetComponent === 'diagnosis'}
                    isLocked={this.state.isLocked}
                    triggerPreviousHistory = {this.triggerPreviousHistory}
                    EditDiagnosisData={this.EditDiagnosisData.bind(this)}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    custom_name = {customName}
                />

            case "patient_category":
                return <DocPatientCategoryLeft
                    PatientData={this.state.PatientData}
                    GetAPiCall={this.state.CallGetComponent === 'patient_category'}
                    isLocked={this.state.isLocked}
                    custom_name = {customName}
                />
                case "Complaints":
                    return <OtherDocComplaintsLeft
                        fromDocModule={true}
                        PatientData={this.state.PatientData}
                        EditComplaintData={this.EditComplaintData.bind(this)}
                        GetAPiCall={this.state.CallGetComponent === 'complaints'}
                        isLocked={this.state.isLocked}
                        UserInfo={UserInfo}
                        SelectedComponent={this.state.SelectedComponent}
                        custom_name = {customName}
                    />

            case "general_advice":
                return <DocGenAdviceleft
                    PatientData={this.state.PatientData}
                    EditGenAdviceText={this.EditGenAdviceText.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'general_advice'}
                    isLocked={this.state.isLocked}
                    custom_name = {customName}
                />

            case "clinical_history":
                return <DocClinicalHistoryLeft
                    PatientData={this.state.PatientData}
                    EditClinicalHistText={this.EditClinicalHistText.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'clinical_history'}
                    isLocked={this.state.isLocked}
                    custom_name = {customName}
                />

            case "allergies":
                return <DocAllergiesLeft
                    PatientData={this.state.PatientData}
                    EditAllergyData={this.EditAllergyData.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'allergies'}
                    isLocked={this.state.isLocked}
                    SelectedComponent={this.state.SelectedComponent}
                    allergyData={this.allergyData}
                    custom_name = {customName}
                />

            case "prescription":
                return <DocPrescriptionLeft
                    PatientData={this.state.PatientData}
                    EditPrescriptionData={this.EditPrescriptionData.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'prescription'}
                    AddPrescritionItem={this.state.AddPrescritionItem}
                    ClearClickedonRightPrecs={this.state.ClearClickedonRightPrecs}
                    isLocked={this.state.isLocked}
                    handleDisableTransfer={this.handleDisableTransfer.bind(this)}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    getPrescriptionData = {(list) => {this.setState({prescriptionList: list})}}
                    custom_name = {customName}
                />
            case "test":
                return this.state.isNewBilling ? (
                    <DocTestLeft
                        PatientData={this.state.PatientData}
                        GetAPiCall={this.state.CallGetComponent === 'test'}
                        isLocked={this.state.isLocked}
                        custom_name={customName}
                    />
                ) : (
                    <OldDocTestLeft
                        PatientData={this.state.PatientData}
                        GetAPiCall={this.state.CallGetComponent === 'test'}
                        isLocked={this.state.isLocked}
                        custom_name={customName}
                    />
                );
            case "plan":
                return <DocPlanLeft
                    EditPlanDatas={this.EditPlanDatas.bind(this)}
                    PatientData={this.state.PatientData}
                    GetAPiCall={this.state.CallGetComponent === 'plan'}
                    isLocked={this.state.isLocked}
                    SelectedComponent={this.state.SelectedComponent}
                    custom_name = {customName}
                />
            case "counselling":
                return <DocCounsellingLeft
                    EditCounsellingData={this.EditCounsellingData.bind(this)}
                    PatientData={this.state.PatientData}
                    GetAPiCall={this.state.CallGetComponent === 'counselling'}
                    isLocked={this.state.isLocked}
                    handleDisableTransfer={this.handleDisableTransfer.bind(this)}
                    custom_name = {customName}
                />

            case "vitals":
                return <DocVitalsLeft
                    PatientData={this.state.PatientData}
                    GetAPiCall={this.state.CallGetComponent === 'vitals'}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    custom_name = {customName}
                    EditVitalsData={this.setVitalsData.bind(this)}
                    filteredRightField_data = {this.state.filteredRightField_data}
                />

            case 'review_plan':
                return <DocReviewPlanLeft
                    appointmentId={this.state.appointmentId}
                    isLocked={this.state.isLocked}
                    GetAPiCall={this.state.CallGetComponent === 'review_plan'}
                    EditReviewPlanData={this.EditReviewPlanData.bind(this)}
                    custom_name = {customName}
                />

            case 'clinicExam':
                return <DocClinicExamENTLeft
                    appointmentId={this.state.appointmentId}
                    PatientData={this.state.PatientData}
                    isLocked={this.state.isLocked}
                    GetAPiCall={this.state.CallGetComponent === 'clinicExam'}
                    clinicalExamNotes={this.state.clinicalExamNotes}
                    EditClinicalExamNotes={this.EditClinicalExamNotes.bind(this)}
                    AddClinicalExamNotes={this.AddClinicalExamNotes.bind(this)}
                    examinePopup={this.state.examinePopup}
                    isDataSaved={this.isDataSaved}
                    custom_name = {customName}
                />

            case "final_diagnosis":
                return <DocFinalDiagnosisLeft
                    PatientData={this.state.PatientData}
                    EditFinalDiagnosisTxt={this.EditFinalDiagnosisTxt.bind(this)}
                    triggerPreviousHistory = {this.triggerPreviousHistory}
                    GetAPiCall={this.state.CallGetComponent === 'final_diagnosis'}
                    isLocked={this.state.isLocked}
                    custom_name = {customName}
                    />

            case 'pain_scale':
                return <DocPainScaleLeft
                    appointmentId={this.state.appointmentId}
                    isLocked={this.state.isLocked}
                    GetAPiCall={this.state.CallGetComponent === 'pain_scale'}
                    EditPainScaleData={this.EditPainScaleData.bind(this)}
                    custom_name={customName}
                />
            
            case "past_history":
                return <DocPastHistoryLeft
                    PatientData={this.state.PatientData}
                    EditPastHistoryData={this.EditPastHistoryData.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'past_history'}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedComponent={this.state.SelectedComponent}
                    custom_name={customName}
                />
            case 'obstetric_data':
                return <DocObstericDataLeft
                    appointmentId={this.state.appointmentId}
                    isLocked={this.state.isLocked}
                    PatientData={this.state.PatientData}
                    GetAPiCall={this.state.CallGetComponent === 'obstetric_data'}
                    EditObstericData={(data) => this.setState({
                        EditObstericData: data
                    })}
                    SelectedComponent={this.state.SelectedComponent}
                    custom_name={customName}
                />    
            case "history_of_presenting_illness":
                return <DocHistoryofIllnessLeft
                    PatientData={this.state.PatientData}
                    EditPresentingIllnessData={this.EditPresentingIllnessData.bind(this)}
                    GetAPiCall={this.state.CallGetComponent === 'history_of_presenting_illness'}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedComponent={this.state.SelectedComponent}
                    custom_name={customName}
                />
            default:
                if (isNew === true) {
                    return <DocNewLayoutLeft
                        key={Component}
                        PatientData={this.state.PatientData}
                        stateValue={this.state.dynamicState[Component]}
                        stateKey={Component}
                        EditNewLayoutText={this.EditNewLayoutText.bind(this)}
                        GetAPiCall={this.callNewLayoutData.bind(this)}
                        isLocked={this.state.isLocked}
                        SelectedComponent={this.state.SelectedComponent}
                        custom_name={customName}
                    />
                }
                return null;
        }
    }

    renderRightComponent(Component) {
        let Userdata = localGetItem("loggedInUserInfo")
        let UserInfo = JSON.parse(Userdata)
        switch (Component) {
            case "symptoms":
                return <DocSymptomsRight
                    EditSymptomsData={this.state.EditSymptomsData}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />

            case "examination":
                return <DocExaminationRight
                    EditExaminationsData={this.state.EditExaminationsData}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />

            case "diagnosis":
                return <DocDiagnosisRight
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    isLocked={this.state.isLocked}
                    EditDiagnosisData={this.state.EditDiagnosisData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                    copyPostData = {this.state.postDiagnosisData}
                    closePreviousPopUp = {this.closePreviousPopUp.bind(this)}
                />

            case "patient_category":
                return <DocPatientCetegoryRight
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />
                case "Complaints":
                    return <OtherDoccomplaintsRight
                        EditComplaintData ={this.state.EditComplaintData}
                        ClearPropsData={this.ClearPropsData.bind(this)}
                        CallgetApi={this.TriggerGetApi.bind(this)}
                        PatientData={this.state.PatientData}
                        isLocked={this.state.isLocked}
                        UserInfo={UserInfo}
                        SelectedCompCustomName={this.state.SelectedCompCustomName}
                    />

            case "general_advice":
                return <DocGenAdviceRight
                    EditGenAdviceText={this.state.EditGenAdviceText}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />

            case "clinical_history":
                return <DocClinicalHistoryRight
                    EditClinicalHistText={this.state.EditClinicalHistText}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />

            case "allergies":
                return <DocAllergiesRight
                    EditAllergyData={this.state.EditAllergyData}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    allergyData={this.state.allergyData}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />
            case "prescription":
                return <DocPrecriptionRight
                    EditPrescriptionData={this.state.EditPrescriptionData}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearClickedonRightPrecs={this.ClearClickedonRightPrecs.bind(this)}
                    AddPrescritionItem={this.AddPrescritionItem.bind(this)}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    prescripTblData = {this.state.prescriptionList || []}
                />
            case "test":
                return this.state.isNewBilling ? (
                    <DocTestRight
                        CallgetApi={this.TriggerGetApi.bind(this)}
                        PatientData={this.state.PatientData}
                        ClearPropsData={this.ClearPropsData.bind(this)}
                        isLocked={this.state.isLocked}
                        SelectedCompCustomName={this.state.SelectedCompCustomName}
                    />
                ) : (
                    <OldDocTestRight
                        CallgetApi={this.TriggerGetApi.bind(this)}
                        PatientData={this.state.PatientData}
                        ClearPropsData={this.ClearPropsData.bind(this)}
                        isLocked={this.state.isLocked}
                        SelectedCompCustomName={this.state.SelectedCompCustomName}
                    />
                );

            case "plan":
                return <DocPlanRight
                    EditPlanDatas={this.state.EditPlanDatas}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                    clinicID = {this.state.clinicId}
                />

            case "counselling":
                return <DocCounsellingRight
                    EditCounsellingData={this.state.EditCounsellingData}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />

            case "vitals":
                return <DocVitalsRight
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                    EditVitalsData={this.state.EditVitalsData}
                    right_Fields_data = {this.state.right_Fields_data}
                    filteredRightField_data = {this.state.filteredRightField_data}
                />

            case 'review_plan':
                return <DocReviewPlanRight
                    EditReviewPlanData={this.state.EditReviewPlanData}
                    appointmentId={this.state.appointmentId}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    callGet = {this.TriggerGetApi.bind(this)}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />

            case 'clinicExam':
                return <DocClinicExamENTRight
                    EditClinicalExamNotes={this.state.EditClinicalExamNotes}
                    AddClinicalExamNotes={this.AddClinicalExamNotes.bind(this)}
                />
            
            case 'final_diagnosis':
                return <DocFinalDiagnosisRight
                    EditFinalDiagnosisTxt={this.state.EditFinalDiagnosisTxt}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                    copyPostData = {this.state.postFnlData}
                    closePreviousPopUp = {this.closePreviousPopUp.bind(this)}
                />
            case 'pain_scale':
                return <DocPainScaleRight
                    EditPainScaleData={this.state.EditPainScaleData}
                    appointmentId={this.state.appointmentId}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    isLocked={this.state.isLocked}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />
            
            case "past_history":
                return <DocPastHistoryRight
                    EditPastHistoryData={this.state.EditPastHistoryData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />
            case 'obstetric_data':
                return <DocObstericDataRight
                    isLocked={this.state.isLocked}
                    PatientData={this.state.PatientData}
                    EditObstericData={this.state.EditObstericData}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                />
            case "history_of_presenting_illness":
                return <DocHistoryofIllnessRight
                    EditPresentingIllnessData={this.state.EditPresentingIllnessData}
                    ClearPropsData={this.ClearPropsData.bind(this)}
                    CallgetApi={this.TriggerGetApi.bind(this)}
                    PatientData={this.state.PatientData}
                    isLocked={this.state.isLocked}
                    UserInfo={UserInfo}
                    SelectedCompCustomName={this.state.SelectedCompCustomName}
                />
            default:
                if (this.state.isNewLayout) {
                    return <DocNewLayoutRight
                        key={Component}
                        EditNewLayoutText={this.state.editDynamicState[this.state.SelectedComponent]}
                        stateKey={Component}
                        layoutDetail={this.state.isNewLayout}
                        CallgetApi={this.callNewLayoutData.bind(this)}
                        PatientData={this.state.PatientData}
                        ClearPropsData={this.ClearPropsData.bind(this)}
                        isLocked={this.state.isLocked}
                        SelectedCompCustomName={this.state.SelectedCompCustomName} />
                }
                return null;
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }
    ClosePopUp() {
        this.setState({
            OpenDrawer: false,
        })
    }

    handleDiagnosisCopy = (from = "both", passedData) => {
        const states = this.state;
        let data = {
            appointment_id: states?.PatientData?.appointment_id,
            patient_id: states?.PatientData?.patient_id,
        }
        switch (from) {
            case "IcdCode":
                data["icd_codes"] = passedData?.length > 0 ? passedData?.map((item) => item.icd_code) : [];
                break;
            case "diagnosis":
                data["provisional_diagnosis"] = passedData || ""
                break;
            default:
                data["icd_codes"] = passedData?.icd_code?.length > 0 ? passedData?.icd_code?.map((item) => item.icd_code) : [];
                data["provisional_diagnosis"] = passedData?.diagnosis || "";
                break;
        }
        this.setState({
            postDiagnosisData: data
        })
    }

    handleFnlDiagnosisCopy = (from = "both", passedData) => {
        const states = this.state;
        let data = {
            appointment_id: states?.PatientData?.appointment_id,
            patient_id: states?.PatientData?.patient_id,
            system_name: 'Final Diagnosis',
            custom_name: states.title ? states.title : '',
        }
        console.log("called from previous copy")

        switch (from) {
            case "IcdCode":
                data["icd_codes"] = passedData?.map((item) => ({ ...item, id: null })) || [];
                break;
            case "diagnosis":
                data["comments"] = passedData || ""
                break;
            default:
                data["icd_codes"] = passedData?.icd_code?.length > 0 ? passedData?.icd_code?.map((item) => ({ ...item, id: null })) : [];
                data["comments"] = passedData.diagnosis || "";
                break;
        }
        this.setState({
            postFnlData: data
        })
    }

    getSpecInfo = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION + `?clinic_id=${this.state.clinicId}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                        let datas = response.data.data ? response.data.data : []
                        let SpecList = []
                        let Specialization = []
                        if (this.state.TranferMethod === "Transfer Appointment") {
                            SpecList = datas?.filter((item) => (item.is_active === true && item.id === UserData?.specialization_id))
                        } else {
                            Specialization = datas?.filter((item) => (item.is_active === true))
                        }
                        this.setState({
                            spcInfo: SpecList,
                            SpecializationInfo: Specialization,
                            selectedspec: SpecList[0],
                            SpecdocDetails: this.state?.docDetails?.filter((item) => (item?.specialization_id === SpecList[0]?.id))
                        });
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message);
                    }
                });
        } catch (e) {
            this.errorMessage(e.message);
        }
    }

    PostAddendum = () => {
        try {
            let data = {
                addendum_notes: this.state.Addcomments,
                appointment_id: this.state.appointmentId,
            }
            RestAPIService.create(data, Serviceurls.GET_ADDENDUM_LOG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response.data.message)
                        this.setState({ addendumPopup: false, Addcomments: "" }, () => {
                            this.getDoctorPatientAppointment()
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    postPatientStatus = (status) => {
        const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let { history } = this.props;
        try {
            var states = this.state
            var data = {}
            if (status == "Scan/Surgery") {
                data = {
                    "appointment_id": this.state.appointmentId,
                    "appointment_status": status,
                    "waiting_timer": null,
                    "clinic_id" : this.state.clinicId,
                }
            } else if (status == "Completed") {
                data = {
                    "appointment_id": this.state.appointmentId,
                    "appointment_status": "Completed",
                    "waiting_timer": null,
                    "clinic_id" : this.state.clinicId,
                }
            } else {
                data = {
                    "appointment_id": this.state.appointmentId,
                    "appointment_status": "Completed",
                    "waiting_timer": null,
                    "is_transfered": true,
                    "transfer_doctor_id": this.state.Doctor?.doctor_id ? this.state.Doctor?.doctor_id : null,
                    "transfer_id": states?.transferId ? states?.transferId : null,
                    "clinic_id" : this.state.clinicId,
                }
            }
                        RestAPIService.create(data, Serviceurls.DOC_APPOINTMENT_STATUS_UPDATE)
                .then(response => {
                    if (response.data.status == "success") {
                        this.setState({
                            scan_status: false
                        })
                        let smsConfig = localGetItem("smsConfig") ? JSON.parse(localGetItem("smsConfig")) : {}
                        if (status === "Completed" && (smsConfig?.appointment_completed_sms || UserData?.whatsapp_config?.doctor_visit_report)) {
                            this.setState({
                                successPopup: true,
                                successPopupTxt: response.data.message,
                                smsSuccessTxt: response.data.sms_message,
                                isWahtsAppText: response.data.whatsapp_message
                            })
                        } else {
                            history.push({ pathname: "/DoctorHome" })
                        }
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === "fail") {
                        this.errorMessage(e.response.data.message)
                    } else {
                        this.errorMessage(e.message)
                    }
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    postDoctorAppointmentCreate = () => {
        try {
            var states = this.state

            var AptDateTime = new Date()

            var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')

            var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let clinicId = getCachevalue('SelectedDoctorClinic')
            if((states.Doctor === '' || states.Doctor === null) && this.state.doctorMandatory){
                this.errorMessage("Select Doctor")
            } else if(states.Specilazation === "" || states.Specilazation === null){
                this.errorMessage("Select Specilazation")
            } else if(states.PurposeOfVisit === ''){
                this.errorMessage("Select Purpose of Visit")
            } else{
            // if (states.Doctor?.doctor_id && states.Specilazation?.id && states.PurposeOfVisit) {
                var data = {
                    patient_id: this.state.patientId,
                    doctor_id: states.Doctor?.doctor_id ? states.Doctor?.doctor_id : null,
                    speciality_id: states.Specilazation?.id ? states.Specilazation?.id : null,
                    purpose_of_visit: states.PurposeOfVisit,
                    patient_tag_id: states.selectedTagId?.id,
                    appointment_date: AptDate,
                    appointment_start_time: Aptime,
                    patient_appointment_type: states.selectedAppointTypeId === null ? null : states.selectedAppointTypeId?.id ? states.selectedAppointTypeId?.id : 3,
                    nurse_id: states.selectedNurseId?.staff_id ? states.selectedNurseId?.staff_id : null,
                    request_id: this.state.RequestedPatientData?.id ? this.state.RequestedPatientData?.id : null,
                    clinic_id: +clinicId,
                    new_appointment: true,
                    transfer_appointment: true,
                    appointment_id: this.state.appointmentId || null,
                }
                RestAPIService.create(data, Serviceurls.DOC_PATIENT_APPOINTMENT)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.successMessage(response.data.message)
                            this.setState({ TransferPopup: false,postAppTransLoad:false })
                            this.postPatientStatus()
                        }
                    }).catch((error) => {
                        this.setState({postAppTransLoad:false})
                        if (error?.response?.data?.message) {
                            this.errorMessage(error.response.data.message)
                        } else {
                            this.errorMessage(error.message)
                        }
                    })
                }
            // }
            // else {
            //     this.errorMessage("Kindly Select the Mandatory Fields")
            // }
        } catch (error) {
            this.setState({postAppTransLoad:false})
            this.errorMessage(error.message)
        }
    }

    PostTransfer = () => {
        let { history } = this.props;
        try {
            let data = {
                "clinic_id": this.state.clinicId,
                "appointment_id": this.state?.appointmentId,
                "doctor_id": this.state.selectedDoc?.doctor_id,
                "patient_id": this.state.patientId,
                "transfer_notes": this.state.comments
            }
            if ((this.state.selectedDoc === null || this.state.selectedDoc === '') && this.state.doctorMandatory) {
                this.errorMessage("Kindly Select the Mandatory Fields")
            } else {
                RestAPIService.create(data, Serviceurls.DOC_TRANSFER_REQUEST)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response.data.message)
                        this.setState({
                            TransferPopup: false,
                            postTransLoad:false
                        }, () => {
                            clearCachevalue("DoctorPatientData")
                            history.push({ pathname: "/DoctorHome" })
                        })
                    }
                }).catch((error) => {
                    this.setState({postTransLoad:false})
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
            }
        } catch (error) {
            this.setState({postTransLoad:false})
            this.errorMessage(error.message)
        }
    }

    TransferAppointPopup = () => {
        let states = this.state
        return (
            <div>
                <Modal open={this.state.TransferPopup}>
                    <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "33vw", height: "60vh", maxHeight: "100%" }}>
                        <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontWeight={600}>Transfer Appointment</Typography>
                            <Button
                                className='Common_Btn_Min_Width'
                                onClick={() => this.setState({ TransferPopup: false, TranferMethod: "Transfer Appointment", selectedDoc: null, selectedspec: null, comments: "", PurposeOfVisit: "" })}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <Box component={'div'}>
                            <Box component={'div'} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                <RadioGroup value={this.state.TranferMethod}
                                    sx={{ display: 'flex', flexDirection: 'row', marginTop: "0.65vw" }}
                                    onClick={(e) => { this.setState({ TranferMethod: e.target.value, selectedspec: null, selectedDoc: null, filteredDocList: [], Specilazation: null, Doctor: null, PurposeOfVisit: "" }, () => { this.getSpecInfo() }) }}
                                >
                                    <FormControlLabel value={'Transfer Appointment'} control={<Radio size='small' />} label='Transfer Doctor' />
                                    <FormControlLabel value={'New Appointment'} control={<Radio size='small' />} label='Transfer Appointment' />
                                </RadioGroup>
                            </Box>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: "0.5vw", marginBottom: "0.5vw" }}>
                                <div style={{ marginLeft: "1vw", marginTop: "0.65vw" }}>
                                    {this.state?.TranferMethod === "Transfer Appointment" ? <Autocomplete
                                        clearIcon
                                        freeSolo
                                        size='small'
                                        sx={{ width: "15vw" }}
                                        options={this.state.spcInfo}
                                        getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.name}
                                        value={this.state?.selectedspec}
                                        onChange={(e, newValue) => {
                                            states["selectedspec"] = newValue
                                            this.setState({
                                                states
                                            })
                                        }}
                                        renderInput={(params) => <TextField {...params} label='Specialization *' />}
                                    /> :
                                        this.renderSuggestionDropDown("Specialization", "Specilazation", this.state.SpecializationInfo)
                                    }
                                </div>
                                <div style={{ marginLeft: "1vw", marginTop: "0.65vw" }}>
                                    {this.state?.TranferMethod === "Transfer Appointment" ? <Autocomplete
                                        clearIcon
                                        freeSolo
                                        size='small'
                                        sx={{ width: "15vw" }}
                                        options={this.state.SpecdocDetails}
                                        getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.doctor_name}
                                        value={this.state?.selectedDoc}
                                        onChange={(e, newValue) => {
                                            states["selectedDoc"] = newValue
                                            this.setState({
                                                states
                                            })
                                        }}
                                        renderInput={(params) => <TextField {...params} label={this.state.doctorMandatory ? 'Doctor *' : 'Doctor'} />}
                                    /> :
                                        this.renderSuggestionDropDown("Doctor", "Doctor", this.state.filteredDocList.length > 0 ? this.state.filteredDocList : this.state.docDetails)
                                    }
                                </div>
                            </div>
                            {this.state.TranferMethod == "New Appointment" ? <Box sx={{ paddingLeft: "1vw", paddingBottom: "0.5vw" }}>
                                <Autocomplete
                                    inputProps={{ maxLength: 90 }}
                                    options={states.POVList}
                                    getOptionLabel={(options) => options}
                                    onChange={(e, value) => {
                                        this.setState({
                                            PurposeOfVisit: value
                                        })
                                    }}
                                    clearIcon={false}
                                    size='small'
                                    sx={{ width: "31vw" }}
                                    value={states.PurposeOfVisit}
                                    renderInput={(params) => <TextField onChange={(event) => {
                                        this.setState({
                                            PurposeOfVisit: event.target.value
                                        })
                                    }}
                                        {...params}
                                        placeholder="Purpose Of Visit *"
                                    />}
                                />
                            </Box> : null}
                            <div style={{ fontWeight: 600, marginLeft: "0.5vw", color: Colors.SecondaryText }}>Notes</div>
                            <div style={{ height: "10vw", width: "95%", paddingLeft: "1vw" }}>
                                <TextField
                                    label={("Enter Description")}
                                    style={{ height: "8vw", marginTop: "0.75vw", width: "100%" }}
                                    multiline={true}
                                    rows={4}
                                    variant="outlined"
                                    value={this.state.comments}
                                    onChange={(event) => {
                                        let value = event.target.value
                                        if (value?.length <= 250) {
                                            this.setState({ comments: value })
                                        } else {
                                            this.errorMessage('Allowed only 250 characters')
                                        }
                                    }}
                                />
                            </div>
                            <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
                                <Button
                                    sx={{ height: '2vw', width: '7vw', textTransform: 'capitalize', mr: '1vw' }}
                                    variant='contained'
                                    onClick={() => { this.setState({ TransferPopup: false, TranferMethod: "Transfer Appointment", selectedDoc: null, selectedspec: null, comments: "", PurposeOfVisit: "" }) }}
                                >Cancel</Button>
                                <Button
                                    sx={{ height: '2vw', textTransform: 'capitalize' }}
                                    variant='contained'
                                    onClick={() => { this.state.TranferMethod == "Transfer Appointment" ? this.setState({postTransLoad:true} ,() => this.PostTransfer())  : this.setState({postAppTransLoad:true},() => this.postDoctorAppointmentCreate()) }}
                                >{this.state.TranferMethod == "Transfer Appointment" ? 'Transfer' : 'create Appointment'}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            </div >
        )
    }

    renderSuggestionDropDown = (label, stateKey, Data) => {
        let states = this.state;
        return (
            <Autocomplete
                size='small'
                clearIcon={false}
                sx={{ width: '15vw' }}
                options={Data}
                getOptionLabel={(item) => (label === "Doctor" ? item.doctor_name : item.name)}
                value={states[stateKey]}
                onChange={(event, newValue) => {
                    states[stateKey] = newValue
                    if (newValue !== null && "doctor_id" in newValue) {
                        let docDetail = { ...newValue }
                        docDetail["name"] = docDetail["specialization_name"];
                        delete docDetail.specialization_name;
                        docDetail["id"] = docDetail["specialization_id"];
                        delete docDetail.specialization_id;
                        states["Specilazation"] = docDetail;
                    }
                    if (newValue !== null && "name" in newValue) {
                        let filteredLst = states["docDetails"].length > 0 && states["docDetails"].filter(item => item["specialization_id"] === newValue["id"])
                        states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
                        states["Doctor"] = null;
                    }
                    if (newValue === null && label === "Specialization") {
                        states["filteredDocList"] = states["docDetails"];
                    }
                    this.setState({ states })
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label + `${(label === "Doctor" && this.state.doctorMandatory || label === "Specialization") ? " *" : ""}`}
                        placeholder={label}
                    />
                )}
            />
        )
    }

    addendumPopup = () => {
        return (
            <div>
                <Modal open={this.state.addendumPopup}>
                    <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "33vw", height: "40vh", maxHeight: "100%" }}>
                        <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Addendum</Typography>
                            <Button
                                className='Common_Btn_Min_Width'
                                onClick={() => this.setState({ addendumPopup: false, Addcomments: "" })}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", margin: "0vw 1vw" }}>
                            <div style={{ fontWeight: 600, color: Colors.SecondaryText }}>Reason</div>
                            {this.state.addendumLogList?.length > 0 ? <div className="eMed_icon_styles" style={{ backgroundColor: !this.props.isLocked ? Colors.ThemeColor : Colors.disableComponentColor }} onClick={() => { this.setState({ addendumLogPopup: true }) }}>
                                <Tooltip placement='top' title='Addendum Log'>
                                    <Box component={'img'} src={ImagePaths.EyeView.default} height={'1.5vw'} width={'1.5vw'} />
                                </Tooltip>
                            </div> : null}
                        </div>
                        <div style={{ height: "10vw", width: "95%", paddingLeft: "1vw" }}>
                            <TextField
                                label={("Enter Description")}
                                style={{ height: "8vw", marginTop: "0.75vw", width: "100%" }}
                                multiline={true}
                                rows={4}
                                variant="outlined"
                                value={this.state.Addcomments}
                                onChange={(event) => {
                                    let value = event.target.value
                                    if (value?.length <= 250) {
                                        this.setState({ Addcomments: value })
                                    } else {
                                        this.errorMessage('Allowed only 250 characters')
                                    }
                                }}
                            />
                        </div>
                        <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
                            <Button
                                sx={{ height: '2vw', width: '7vw', textTransform: 'capitalize', mr: '1vw' }}
                                variant='contained'
                                onClick={() => { this.setState({ addendumPopup: false, Addcomments: "" }) }}
                            >Cancel</Button>
                            <Button
                                sx={{ height: '2vw', width: '7vw', textTransform: 'capitalize' }}
                                variant='contained'
                                onClick={() => {
                                    if (this.state.Addcomments != "") {
                                        this.PostAddendum()
                                    } else {
                                        this.errorMessage('Enter Addendum Comments')
                                    }
                                }}
                            >Addendum</Button>
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }

    formatDateTime = (dateTimeString) => {
        const dateObj = new Date(dateTimeString);

        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();
        const formattedTime = dateObj.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        return `${day}-${month}-${year} ${formattedTime}`;
    }

    addendumLogPopup = () => {
        return (
            <div>
                <Modal open={this.state.addendumLogPopup}>
                    <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "45vw", height: "60vh", maxHeight: "100%" }}>
                        <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Addendum Log</Typography>
                            <Button className='Common_Btn_Min_Width' onClick={() => this.setState({ addendumLogPopup: false })}>
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <Box>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600, backgroundColor: Colors.Background }}>
                                                {"S.No"}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600, backgroundColor: Colors.Background }}>
                                                {"Created By"}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600, backgroundColor: Colors.Background }}>
                                                {"Created Date & Time"}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600, backgroundColor: Colors.Background }}>
                                                {"Notes"}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.addendumLogList?.length > 0 ? (
                                            this.state.addendumLogList.map((item, index) => {
                                                const truncatedNotes = item?.notes?.length > 30 ? item.notes.slice(0, 30) + "..." : item?.notes;
                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{item?.created_by ? item.created_by : "-"}</TableCell>
                                                        <TableCell>{item?.created_date ? this.formatDateTime(item?.created_date) : "-"}</TableCell>
                                                        <TableCell>
                                                            {item?.notes?.length > 30 ? (
                                                                <Tooltip title={item?.notes} arrow>
                                                                    <span style={{ cursor: "pointer" }}>{truncatedNotes}</span>
                                                                </Tooltip>
                                                            ) : (
                                                                item?.notes || "-"
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={3} align="center">No data available</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }

    getDoctorPatientAppointment = () => {
        let { history } = this.props;
        try {
            RestAPIService.getAll(Serviceurls.FO_GET_APPOINMENT_DETAILS + '?clinic_id=' + this.state.clinicId + '&appointment_id=' + this.state.appointmentId)
                .then((response) => {
                    if (response) {
                        this.setState({
                            appointmentDetails: response.data.data,
                            isLocked: response.data.data?.is_locked
                        }, () => {
                            setCachevalue(JSON.stringify(this.state.appointmentDetails), 'DoctorPatientData')
                            // history.push({ pathname: "/DoctorHome" })
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }


    postTransmitSummary = () => {
        try {
            let data = {}
            RestAPIService.create(data, Serviceurls.DOC_TRANSMIT_POST + this.state.appointmentId + "/")
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response.data.message)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    lockDoctorNotes = () => {
        try {
            let data = {
                appointment_id: this.state.appointmentId,
                status: 'appointment lock'
            }
            RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_LOCK + `${this.state.appointmentId}/lock/`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response.data.message)
                        this.getDoctorPatientAppointment()
                        // this.postTransmitSummary()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    confirmSave = () => {
        this.setState({
            confirmpopup: false
        }, () => {
            this.lockDoctorNotes()
        })
    }

    statusChange = () => {
        this.setState({
            statuspopup: false
        }, () => {
            if (this.state?.scan_status) {
                this.postPatientStatus("Scan/Surgery")
            } else {
                this.postPatientStatus("Completed")
            }
        })
    }

    popClose = () => {
        this.setState({
            confirmpopup: false
        })
    }

    statuspopClose = () => {
        this.setState({
            statuspopup: false
        })
    }

    HideRightComponent(Component) {
        switch (Component) {
            case "prescription": return (this.state.PatientData?.is_prescription_transmitted || this.state.PatientData?.is_transmitted)
            case "counselling": return (this.state.PatientData?.is_transmitted)
            case "clinicExam": return true
            default: return false
        }
    }

      ClosesuccessPopUp = () => {
        this.setState({
            successPopup: false
        })
        this.props.history.push({ pathname: "/DoctorHome" })
    }
    
    renderSuccessPopup = () => {
        const userData = JSON.parse(localGetItem("loggedInUserInfo"))
        return (
            <div>
                <Modal
                    open={true}
                >
                    <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={'30vh'}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2vw' }}>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                <img className='' src={ImagePaths.Tick.default} />
                                <Typography fontWeight={600}>{this.state.successPopupTxt ? this.state.successPopupTxt : 'Appointment Completed Successfully'}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                {this.state.smsSuccessTxt ? <ErrorIcon color='error' /> : <img src={ImagePaths.Tick.default} alt='success' />}
                                <Typography fontWeight={600}>{this.state.smsSuccessTxt ? this.state.smsSuccessTxt : 'SMS Sent Successfully'}</Typography>
                            </Box>
                            {(userData?.whatsapp_configuration && this.state.isWahtsAppText === '') ? <Box sx={{ display: 'flex', gap: '1vw' }}>
                                {<img src={ImagePaths.Tick.default} alt='success' />}
                                <Typography fontWeight={600}>{this.state.isWahtsAppText || 'WhatsApp Message Sent Successfully'}</Typography>
                            </Box> : null}
                        </Box>
                        <Box display={'flex'} gap={'0.5vw'}>
                            <Button sx={{ textTransform: 'capitalize', }} size="small" variant="outlined" onClick={this.ClosesuccessPopUp}>{"OK"}</Button>
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }

    renderPrimarydetails = () => {
        const { patientPrimType } = this.state;
        return patientPrimType?.insurance_company_name
            ? renderCorpInsuranceCard("Insurance Details", patientPrimType.insurance_company_name)
            : patientPrimType?.employer_name
                ? renderCorpInsuranceCard("Corporate Details", patientPrimType.employer_name)
                : null;
    }

    render() {
        const { t } = this.props
        let { history } = this.props
        let { PatientData } = this.state
        let consultant = {
            lineOne: t("ConsultantName"),
            lineTwo: `${PatientData?.doctor_name != null ? PatientData?.doctor_name : '-'}`,
        }
        let LockDocNotes;
        if (localGetItem('DoctorNotesLock') === 'false') {
            LockDocNotes = true
        } else {
            LockDocNotes = false
        }
        return (
            <Box sx={{ backgroundColor: Colors.ComponentBgColor }}>
                <Box component={'div'} marginLeft={'0.5vw'} className='eMed_patient_header eMed_OtherDocNotes_Header'>
                    <Box display={'flex'} alignItems='center'>
                        <Box className='eMed_Patient_Details_Long eMed_patient_box'>
                            <CommonPatientDetails data={this.state.PatientData} showDetailed={true} fromDoctor={true} hideInsurance = {true}/>
                        </Box>
                        <ConsultantPatientCard name={consultant} width={"15dvw"}/>
                        <Box component={'div'} onClick={() => { history.push({ pathname: "/DoctorHome/Reports/DoctorVisit" }) }} className='doc_header_card' sx={{ width: "6vw", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }} mr={'0.5vw'}>
                            <Box component={'img'} src={ImagePaths.PreviousPrescription.default} height={'1.8vw'} width={'1.8vw'} />
                            <div style={{ fontSize: "0.85vw" }}>Visit Log</div>
                        </Box>
                        {(this.state.allergyData?.length > 0) &&  (!this.state.allergyData?.some((item)=> item.allergy_type === 3)) ?
                            <Tooltip placement='top' title={this.state.allergyData?.map(item => item.name).join(",")} arrow>
                                <Box component={'div'} className='doc_header_card' sx={{ width: "6vw", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }} mr={'0.5vw'}>
                                    <Box component={'img'} src={ImagePaths.AllergyAlert.default} height={'2vw'} width={'2vw'} />
                                    <div style={{ fontSize: "0.7vw" }}>Allergy</div>
                                </Box>
                            </Tooltip> : null}
                        {this.renderPrimarydetails()}
                    </Box>

                    <Box>
                        <Button
                            emed_tid='transfer_doc_notes'
                            sx={{ textTransform: 'capitalize', mr: '1vw' }}
                            size="small"
                            variant='contained'
                            disabled={this.state.disableButton || this.state.TansmitDisable || this.state.TransferDisable || this.state.isLocked || PatientData?.appointment_status === "Completed"}
                            onClick={() => { this.setState({ TransferPopup: true }, () => { this.getSpecInfo() }) }}
                        >TRANSFER</Button>
                        <Button
                            emed_tid={this.state.isLocked ? "addendum_doc_notes" : "lock_doc_notes"}
                            sx={{ textTransform: 'capitalize' }}
                            variant='contained'
                            size="small"
                            disabled={getCachevalue("DoctorUserChanged") === 'true' ? true : (this.state.isLocked ? LockDocNotes : false ) }
                            onClick={() => { this.state.isLocked ? this.setState({ addendumPopup: true },() => {this.getAddendumLogData()}) : this.setState({ confirmpopup: true }) }}
                        >{this.state.isLocked ? "ADDENDUM" : "LOCK"}</Button>
                        <Button
                            emed_tid='complete_doc_notes'
                            sx={{ textTransform: 'capitalize', ml: '1vw' }}
                            size="small"
                            variant='contained'
                            disabled={this.state.disableButton || PatientData?.appointment_status === "Completed" || this.state.isLocked}
                            onClick={() => { this.setState({ statuspopup: true }) }}
                        >COMPLETE</Button>
                        <Button emed_tid='doc_notes_open_drawer' sx={{ width: '2vw' }} className="eMed_Other_DocNotes_DrawerIcon" onClick={() => { this.setState({ OpenDrawer: true }) }} onMouseEnter={() => { this.setState({ OpenDrawer: true }) }}>
                            <MenuOpenIcon color='primary' />
                        </Button>
                    </Box>
                </Box>
                <Box display={'flex'} flexDirection={'row'} marginTop={"0.5vw"}>
                    <Paper elevation={3} className='eMed_DocNotes_Left_Main' sx={{ height: '68.8vh' }}>
                        {this.state.layoutloading ?
                            <Box>
                                <Skeleton variant="rounded" animation="wave" width={'97%'} height={'25vh'} sx={{ margin: '1vw' }} />
                                <Skeleton variant="rounded" animation="wave" width={'97%'} height={'25vh'} sx={{ margin: '1vw' }} />
                                <Skeleton variant="rounded" animation="wave" width={'97%'} height={'10vh'} sx={{ margin: '1vw' }} />
                            </Box>
                            : this.state.DocNotesLayout.map((item, index) => (
                                item?.is_active ?
                                    <Box ref={this.divRefs[index]} sx={{ padding: '0.5vw' }} >
                                        <Card key={index} onClick={() => { this.setState({ SelectedComponent: item.field_name, SelectedCompCustomName: item.custom_name, isNewLayout: item?.is_new ? item : {} }) }} elevation={3} sx={{ border: `0.15vw solid ${item.field_name === this.state.SelectedComponent ? Colors.themeDark : Colors.white}`, }} >
                                            <Box sx={{ display: 'flex', flexDirection: showRow?.has(item.field_name) ? 'row' : 'column', justifyContent: item?.field_name === "clinicExam" ? 'space-between' : 'flex-start' }}>
                                                <Box display={'flex'} alignItems={'center'} marginLeft={"1vw"}>
                                                    {item.field_name === this.state.SelectedComponent ? <DoubleArrowIcon color='error' sx={{ marginX: '0.5vw', fontSize: '1.2vw' }} /> : null}
                                                    <Typography color={item.field_name === this.state.SelectedComponent ? Colors.themeDark : Colors.SecondaryText} padding={"0.3vw"} fontWeight={600} sx={{ cursor: 'default' }}>{item.custom_name}</Typography>
                                                </Box>
                                                    {item?.field_name === "clinicExam" ?
                                                        <Button variant='contained' size="small" id="eMed_Config_btn" sx={{ margin: '0.5vw' }} disabled={this.state.isLocked || PatientData?.appointment_status === "Completed"}
                                                            onClick={() => { this.setState({ examinePopup: true }) }}>Examine</Button>
                                                        : (item?.field_name === "diagnosis" || item?.field_name === "final_diagnosis") ?
                                                            <Button
                                                                className='Common_Btn_Min_Width'
                                                                disabled={this.state.isLocked}
                                                                onClick={() => {
                                                                    this.setState({ PreviousDiagnosisPopup: true, title: item.custom_name, fieldName: item.field_name })
                                                                }}
                                                            >
                                                            <Tooltip placement='top' title={`Previous ${item.custom_name}`}>
                                                                <HistoryIcon color={this.state.isLocked ? "disabled" : "primary"} sx={{ height: '1.7vw', width: '1.7vw' }} />
                                                            </Tooltip>
                                                            </Button>
                                                            : null}
                                            </Box>
                                            {this.renderComponent(item.field_name, item.custom_name, Boolean(item.is_new))}
                                        </Card>
                                    </Box> : null))}

                    </Paper>
                    <Paper elevation={3} className='eMed_DocNotes_Right_Main' sx={{ height: '68.8vh' }}>
                        {(this.state.layoutloading || this.state.isLocked || this.HideRightComponent(this.state.SelectedComponent)) ?
                            <Box>
                                <Skeleton variant="rounded" animation={this.state.isLocked || this.HideRightComponent(this.state.SelectedComponent) ? false : "wave"} width={'92%'} height={'7vh'} sx={{ margin: '1vw' }} />
                                <Skeleton variant="rounded" animation={this.state.isLocked || this.HideRightComponent(this.state.SelectedComponent) ? false : "wave"} width={'92%'} height={'53vh'} sx={{ margin: '1vw' }} />

                            </Box>
                            : this.renderRightComponent(this.state.SelectedComponent)}
                    </Paper>
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.OpenDrawer}
                    ModalProps={{ onBackdropClick: () => { this.setState({ OpenDrawer: false }) } }}
                >
                    <Box className="eMed_OtherDocNotes_DrawerDiv" onMouseLeave={() => { this.setState({ OpenDrawer: false }) }}>
                        {
                            this.state.DocNotesLayout.map((item, index) => (
                                item?.is_active ?
                                    <Button
                                        emed_tid='doc_notes_moveto_option'
                                        sx={{
                                            textTransform: 'capitalize',
                                            maxWidth: "15vw",
                                            wordBreak: "break-all",
                                            overflowWrap: "break-word",
                                            whiteSpace: "normal",
                                            display: "block",
                                            overflowY: "auto",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                SelectedComponent: item.field_name,
                                                SelectedCompCustomName: item.custom_name,
                                                isNewLayout: item.is_new ? item : {},
                                                OpenDrawer: false
                                            }, () => {
                                                this.divRefs[index]?.current?.scrollIntoView({
                                                    behavior: 'smooth',
                                                    block: 'start',
                                                    inline: 'center'
                                                });
                                            })

                                        }}>
                                        {item.custom_name}
                                    </Button> : null
                            ))
                        }
                    </Box>
                </Drawer>
                {
                    this.state.isErrorMsg ?
                        <ToastMsg
                            severity={"error"}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        /> : null
                }
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successPopup ? this.renderSuccessPopup() : null}
                {this.TransferAppointPopup()}
                {this.addendumPopup()}
                {this.addendumLogPopup()}
                {this.state.confirmpopup ?
                    <ConfirmPopup
                        cnfTitle={'Confirmation'}
                        cnfContent={'Are you sure, Do you want to Lock Doctor Notes'}
                        cnfAlertPopupClose={this.popClose.bind(this)}
                        cnfData={this.confirmSave.bind(this)}
                    />
                    : null}
                {this.state.statuspopup ?
                    <ConfirmPopup
                        cnfTitle={'Confirmation'}
                        cnfContent={'Are you sure, Do you want to change status'}
                        cnfAlertPopupClose={this.statuspopClose.bind(this)}
                        cnfData={this.statusChange.bind(this)}
                    />
                    : null}
                {this.state.PreviousDiagnosisPopup ?
                    <PreviousDiagnosis
                        key={this.state.fieldName}
                        title={this.state.title || this.state.SelectedCompCustomName || ""}
                        title2={this.state.fieldName === "diagnosis" ? "Provisional Diagnosis" :
                            this.state.fieldName === "final_diagnosis" ? "Final Diagnosis" : ""}
                        dateList={this.state.fieldName === "final_diagnosis" ? this.state.fnldateList : this.state.dateList}
                        previousData={this.state.fieldName === "final_diagnosis" ? this.state.fnlPreviousData || [] : this.state.PreviousData || []}
                        isIcdCode={true}
                        is_loading = {this.state.is_previous_loading}
                        onDateChange={(date) => { this.getPreviousDiagnosis(date, this.state.fieldName) }}
                        closePopup={this.closePreviousPopUp.bind(this)}
                        onCopyDiagnosis={(data) => {
                            this.state.fieldName === "final_diagnosis"
                                ? this.handleFnlDiagnosisCopy("both", data)
                                : this.handleDiagnosisCopy("both", data)
                        }}
                        onCopyIcdCode={(data) => {
                            this.state.fieldName === "final_diagnosis"
                                ? this.handleFnlDiagnosisCopy("IcdCode", data)
                                : this.handleDiagnosisCopy("IcdCode", data)
                        }}
                        onCopyDiagnosisTxt={(data) => {
                            this.state.fieldName === "final_diagnosis"
                                ? this.handleFnlDiagnosisCopy("diagnosis", data)
                                : this.handleDiagnosisCopy("diagnosis", data)
                        }}
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(OtherDoctorNotes)